<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-dark fixed-top navbar-shrink" id="mainNav">
  <div class="container">
    <a class="navbar-brand js-scroll-trigger" [routerLink]="['/']">
      <img class="img-fluid mx-auto" id="logo-nav" src="assets/img/logos/favicon.ico" alt=""> 
    </a>
    <ul class="fast-contact">
      <li><a class="hover-link" href="tel:5535160790"> <i class="icon-whatsapp"></i> 55-37-00-63-10</a></li>
      <li><a class="hover-link" href="mailto:andgvo@gmail.com"> <i class="icon-envelop"></i> andgvo@gmail.com </a></li>  
    </ul>
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      Menu <i class="icon-menu"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav text-uppercase ml-auto">
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" [pageScrollDuration]="300" [pageScrollOffset]="52" pageScroll [routerLink]="['/']" href="#skillsAndCompetences">Habilidades y competecias</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" [pageScrollDuration]="300" [pageScrollOffset]="52" pageScroll [routerLink]="['/']" href="#workExperience"> Experiencia </a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" [pageScrollDuration]="300" [pageScrollOffset]="52" pageScroll [routerLink]="['/']" href="#portfolio"> Portfolio </a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" [pageScrollDuration]="300" [pageScrollOffset]="52" pageScroll [routerLink]="['/']" href="#team">Sucursales</a>
        </li>
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" [pageScrollDuration]="300" [pageScrollOffset]="52" pageScroll [routerLink]="['/']" href="#contact">Contacto</a>
        </li>
      </ul>
    </div>
  </div>
</nav>